// extracted by mini-css-extract-plugin
module.exports = {"ol":"NumberedList_ol__vQcl5","li":"NumberedList_li__YDMse"};